const es = {
  nav: {
    overview: 'Resumen', inventory: 'Inventario', crm: 'CRM', wholesale: 'Mayoreo',
    analytics: 'Análisis', vinDecoder: 'Decodificador VIN', profitCalc: 'Calc. Ganancia',
    aiTools: 'Herramientas IA', leadNetwork: 'Red de Leads', salesInvoices: 'Ventas/Facturas',
    expenses: 'Gastos', repairs: 'Reparaciones', docCenter: 'Centro Docs', imagePro: 'Image Pro',
    importExport: 'Importar/Exportar', settings: 'Configuración', signOut: 'Cerrar Sesión',
  },
  landing: {
    hero: 'El Futuro de la Tecnología para Concesionarios',
    heroSub: 'Plataforma completa de gestión — inventario, CRM, herramientas de IA y reportes de historial vehicular en un solo lugar.',
    getStarted: 'Comenzar Gratis',
    viewPricing: 'Ver Precios',
    features: 'Características',
    pricing: 'Precios',
    pricingTitle: 'Precios Simples y Transparentes',
    pricingSub: 'Prueba gratis por 7 días. Sin tarjeta de crédito.',
    perMonth: '/mes',
    subscribe: 'Comenzar',
    currentPlan: 'Plan Actual',
    featuresTitle: 'Todo lo que Necesitas',
    featuresSub: 'Diseñado para concesionarios modernos que quieren ganar.',
    trustedBy: 'Confianza de más de 500 concesionarios en todo el país',
  },
  auth: {
    login: 'Iniciar Sesión',
    register: 'Crear Cuenta',
    email: 'Correo Electrónico',
    password: 'Contraseña',
    confirmPassword: 'Confirmar Contraseña',
    name: 'Nombre Completo',
    companyName: 'Nombre de Empresa / Concesionario',
    phone: 'Número de Teléfono',
    forgotPassword: '¿Olvidaste tu contraseña?',
    noAccount: '¿No tienes cuenta?',
    hasAccount: '¿Ya tienes cuenta?',
    signUp: 'Registrarse',
    signIn: 'Iniciar Sesión',
    resetPassword: 'Restablecer Contraseña',
    sendResetLink: 'Enviar Enlace',
    backToLogin: 'Volver al Inicio de Sesión',
    loggingIn: 'Iniciando sesión...',
    creating: 'Creando cuenta...',
    startTrial: 'Comience su prueba gratuita de 7 días',
    resetSub: 'Ingrese su correo y le enviaremos un enlace para restablecer.',
  },
  dashboard: {
    title: 'Panel de Control',
    totalVehicles: 'Total Vehículos',
    available: 'Disponibles',
    inventoryValue: 'Valor del Inventario',
    conversionRate: 'Tasa de Conversión',
    searchVehicles: 'Buscar vehículos...',
    addVehicle: 'Agregar Vehículo',
    noVehicles: 'No se encontraron vehículos',
  },
  vin: {
    title: 'Decodificador VIN',
    subtitle: 'Ingrese un VIN de 17 caracteres para decodificar',
    decode: 'Decodificar',
    enterVin: 'Ingrese VIN de 17 caracteres',
    wakzyCheck: 'Wakzy Check',
    wakzyCheckSub: 'Reporte Premium de Historial Vehicular — datos de NHTSA',
    runReport: 'Generar Reporte',
    generating: 'Generando Reporte Wakzy Check...',
    generatingSub: 'Verificando retiros, calificaciones de seguridad, quejas y más',
    wakzyScore: 'Puntaje Wakzy',
    noAccidents: 'Sin Accidentes',
    cleanTitle: 'Título Limpio',
    recalls: 'Retiros',
    owners: 'Propietarios',
    personalUse: 'Uso Personal',
    safetyRating: 'Calificación de Seguridad',
    marketValue: 'Valor de Mercado Est.',
    expectedMileage: 'Kilometraje Esperado',
    ownership: 'Propiedad',
    estOwners: 'Propietarios Est.',
    usage: 'Uso',
    vehicleAge: 'Antigüedad',
    years: 'años',
    scoreBreakdown: 'Desglose del Puntaje Wakzy',
    safetySpecs: 'Seguridad y Especificaciones',
    timeline: 'Línea de Tiempo',
    complaints: 'Quejas',
    safetyRatings: 'Calificaciones de Seguridad',
    safetyEquipment: 'Equipo de Seguridad',
    vehicleSpecs: 'Especificaciones del Vehículo',
    vehicleTimeline: 'Línea de Tiempo del Historial',
    cleanHistory: 'Historial Limpio',
    noEvents: 'No se encontraron eventos significativos',
    safetyRecalls: 'Retiros de Seguridad',
    noRecalls: 'No se Encontraron Retiros',
    consumerComplaints: 'Quejas de Consumidores',
    noComplaints: 'No se Encontraron Quejas',
    risk: 'Riesgo',
    fix: 'Solución',
    crashes: 'Choques',
    fires: 'Incendios',
    injuries: 'Lesiones',
    print: 'Imprimir',
    overall: 'General',
    frontalCrash: 'Choque Frontal',
    sideCrash: 'Choque Lateral',
    rollover: 'Volcadura',
    notRated: 'Sin Calificación',
    bodyType: 'Tipo de Carrocería', engine: 'Motor', horsepower: 'Caballos de Fuerza',
    transmission: 'Transmisión', driveType: 'Tracción', fuelType: 'Tipo de Combustible',
    vehicleType: 'Tipo de Vehículo', doors: 'Puertas', trim: 'Versión', country: 'País',
  },
  docs: {
    title: 'Centro de Documentos',
    subtitle: 'Genere, gestione y escanee documentos del concesionario',
    library: 'Biblioteca', generate: 'Generar', templates: 'Plantillas',
    signatures: 'Firmas', aiScanner: 'Escáner IA',
    upload: 'Subir', auditLog: 'Registro de Auditoría',
    total: 'Total', pending: 'Pendiente', expiring: 'Por Vencer',
    expired: 'Vencido', missing: 'Faltante',
    missingDocs: 'Documentos Faltantes',
    searchDocs: 'Buscar VIN, stock #, cliente, archivo...',
    allTypes: 'Todos los Tipos', allStatus: 'Todos los Estados',
    active: 'Activo', archived: 'Archivado',
    document: 'Documento', type: 'Tipo', vinStock: 'VIN / Stock #',
    customer: 'Cliente', status: 'Estado', date: 'Fecha', actions: 'Acciones',
    noDocs: 'No se encontraron documentos',
    uploadFirst: 'Suba o genere su primer documento',
    generateDoc: 'Generar Documento',
    generateClosing: 'Generar Paquete de Cierre',
    closingDesc: 'Carta de Venta + Declaración de Odómetro + Orden del Comprador — todo en una impresión',
    template: 'Plantilla', vehicle: 'Vehículo', selectVehicle: 'Seleccionar vehículo...',
    selectCustomer: 'Seleccionar cliente...',
    salePrice: 'Precio de Venta', dealerFee: 'Tarifa del Dealer', salesTax: 'Impuesto de Venta',
    totalAmount: 'Total', paymentMethod: 'Método de Pago', dateOfSale: 'Fecha de Venta',
    printSavePdf: 'Imprimir / Guardar PDF',
    selectTemplate: 'Seleccione una plantilla y genere',
    autoFill: 'Los documentos se completan automáticamente con datos del vehículo y cliente',
    customTemplates: 'Plantillas Personalizadas', newTemplate: 'Nueva Plantilla',
    noTemplates: 'No hay plantillas personalizadas',
    createTemplates: 'Cree plantillas de documentos reutilizables para su concesionario',
    saveTemplate: 'Guardar Plantilla', updateTemplate: 'Actualizar Plantilla',
    addSection: 'Agregar Sección', addField: 'Agregar Campo',
    templateName: 'Nombre', accentColor: 'Color de Acento', description: 'Descripción',
    autoFillPlaceholders: 'Marcadores de Auto-llenado',
    digitalSignatures: 'Firmas Digitales',
    signaturesSub: 'Firme documentos digitalmente — guardadas para reusar',
    createSignature: 'Crear Nueva Firma',
    savedSignatures: 'Firmas Guardadas',
    noSignatures: 'No hay firmas guardadas',
    scanDocument: 'Escanear Documento',
    scanSub: 'Suba una imagen del documento — la IA extrae VIN, cliente y montos',
    enterpriseFeature: 'Función del Plan Enterprise',
    extractedData: 'Datos Extraídos',
    scanResults: 'Los resultados del escaneo aparecerán aquí',
    applyToUpload: 'Aplicar al Formulario de Subida',
    uploadDocument: 'Subir Documento',
    chooseFile: 'Elegir Archivo',
    uploading: 'Subiendo...',
  },
  imagePro: {
    title: 'Dealer Image Pro',
    subtitle: 'Suite de Fotografía Automotriz con IA',
    dropOrClick: 'Arrastre una imagen o haga clic para subir',
    allFormats: 'Soporta TODOS los formatos — JPEG, PNG, WebP, HEIC, TIFF, BMP, AVIF',
    autoConvert: 'Formatos no estándar se convierten automáticamente a JPEG',
    download: 'Descargar', share: 'Compartir', saveToLibrary: 'Guardar en Biblioteca',
    bgPresets: 'Fondos Prediseñados', customBg: 'Fondo Personalizado',
    uploadBgImage: 'Subir Imagen de Fondo',
    replaceBg: 'Reemplazar Fondo', processing: 'Procesando...',
    copyCaption: 'Copiar Descripción', websiteEmbed: 'Código para Sitio Web',
    sharePost: 'Compartir y Publicar',
  },
  crm: {
    contacts: 'Contactos', addContact: 'Agregar Contacto', searchContacts: 'Buscar contactos...',
    name: 'Nombre', email: 'Correo', phone: 'Teléfono', stage: 'Etapa', source: 'Fuente',
    lastInteraction: 'Última Interacción', noContacts: 'No se encontraron contactos',
  },
  common: {
    save: 'Guardar', cancel: 'Cancelar', delete: 'Eliminar', edit: 'Editar', close: 'Cerrar',
    confirm: 'Confirmar', search: 'Buscar', filter: 'Filtrar', loading: 'Cargando...',
    noData: 'Sin datos', error: 'Error', success: 'Éxito', back: 'Atrás',
    next: 'Siguiente', previous: 'Anterior', submit: 'Enviar', clear: 'Limpiar',
    selectAll: 'Seleccionar Todo', selected: 'seleccionados', download: 'Descargar',
    yes: 'Sí', no: 'No', or: 'O', and: 'y',
    language: 'Idioma',
  },
  admin: {
    overview: 'Resumen', users: 'Usuarios', idVerification: 'Verificación de ID',
    vehicles: 'Vehículos', revenue: 'Ingresos', moderation: 'Moderación',
    announcements: 'Anuncios', emailDigest: 'Resumen de Correo',
    activityLog: 'Registro de Actividad', systemHealth: 'Estado del Sistema',
    platformSettings: 'Config. Plataforma', notifications: 'Notificaciones',
    signOut: 'Cerrar Sesión', totalUsers: 'Total Usuarios', junkLeads: 'Leads de Chatarra',
    estMrr: 'MRR Estimado', thisWeek: 'esta semana', available: 'disponibles',
    active: 'activos', subscribers: 'suscriptores', searchCmd: 'Buscar...',
  },
};

export default es;
